import { Swiper } from '../libs/swiper.js';
// import { initInfrastructureFancybox } from "./fancybox.js";
// Глобальная переменная для хранения экземпляра слайдера истории
let historySwiper = null;

function initSlider() {
  const progressCircle = document.querySelectorAll(
      '.promo-slider__progress svg'
  );
  const progressCounters = document.querySelectorAll('.promo-slider__count');
  const sliders = document.querySelectorAll('[data-slider]');

  const slidersWithThumb = document.querySelectorAll('[data-slider-thumbs]');
  const slidersWithThumbV2 = document.querySelectorAll(
      '[data-slider-thumbs-v2]'
  );
  const newsDetailSliders = document.querySelectorAll('.news-detail-slider');

  if (newsDetailSliders) {
    newsDetailSliders.forEach((newsDetailSlider) => {
      if (!newsDetailSlider.classList.contains('swiper-initialized')) {
        new Swiper(newsDetailSlider, {
          loop: false,
          autoHeight: true,

          navigation: {
            nextEl: newsDetailSlider.querySelector('[data-slider-next]'),
            prevEl: newsDetailSlider.querySelector('[data-slider-prev]'),
          },

          pagination: {
            el: newsDetailSlider.querySelector('[data-slider-points]'),
            bulletClass: 'life-gallery__point',
            bulletActiveClass: 'life-gallery__point--active',
            clickable: false,
          },
        });
      }
    });
  }

  if (document.querySelector('.quotes-slider')) {
    const quotesSlider = new Swiper('.quotes-slider', {
      direction: 'horizontal',
      loop: true,
      autoHeight: true,

      navigation: {
        nextEl: '.quotes-slider [data-slider-next]',
        prevEl: '.quotes-slider [data-slider-prev]',
      },
    });

    quotesSlider.on('slideChangeTransitionEnd', function() {
      if (window.innerWidth <= 743) {
        const topPostion =
          document
              .querySelector('.quotes-slider .swiper-slide-active')
              .getBoundingClientRect().top + window.scrollY;
        scrollTo(0, topPostion - 40);
      }
    });
  }

  if (document.querySelector('.nl-promo__slider')) {
    const newsListSlider = new Swiper('.nl-promo__slider', {
      direction: 'vertical',
      autoHeight: false,
      slidesPerView: 3,
      spaceBetween: 32,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      resistance: true,
      resistanceRatio: 0,
      speed: 5000,
    });

    if (document.querySelector('.nl-promo').offsetHeight > 600) {
      document.querySelector(
          '.nl-promo .nl-promo__slider'
      ).style.maxHeight = `${
        document.querySelector('.nl-promo').offsetHeight
      }px`;
      document.querySelector(
          '.nl-promo__slider-container'
      ).style.maxHeight = `${
        document.querySelector('.nl-promo').offsetHeight
      }px`;
    }
  }

  if (document.querySelector('.promo-slider')) {
    const promoSwiper = new Swiper('.promo-slider', {
      direction: 'horizontal',
      loop: true,

      navigation: {
        nextEl: '.promo-slider__counter--next',
        prevEl: '.promo-slider__counter--prev',
      },

      autoplay: {
        delay: Number(
            document.querySelector('.promo-slider').dataset
                ?.swiperAutoplayDuration || '4000'
        ),
        disableOnInteraction: false,
      },
    });

    promoSwiper.on('transitionEnd', function() {
      progressCounters.forEach((el) => {
        el.innerHTML = promoSwiper.realIndex + 1;
      });
    });

    promoSwiper.on('autoplayTimeLeft', function(swiper, timeLeft, percentage) {
      progressCircle.forEach((el) => {
        el.style.strokeDashoffset = `calc(125.6 + (125.6 * (1 + ${percentage})))`;
      });
    });
  }

  if (sliders.length) {
    sliders.forEach((slider) => {
      if (!slider.classList.contains('swiper-initialized')) {
        const newSlider = new Swiper(slider, {
          direction: 'horizontal',
          loop: true,
          init: false,
          autoHeight: true,
          observer: true,

          navigation: {
            nextEl: slider.querySelector('[data-slider-next]'),
            prevEl: slider.querySelector('[data-slider-prev]'),
          },
        });

        newSlider.on('update', function() {
          const slidesCount = slider.querySelectorAll('.swiper-slide').length;
          const sliderTotalCounter = slider.querySelector(
              '[data-counter-total]'
          );

          if (slidesCount < 2) {
            slider
                .querySelector('.slider__controls')
                .classList.add('visually-hidden');
            return;
          }

          if (slider.querySelector('.slider__controls')) {
            slider
                .querySelector('.slider__controls')
                .classList.remove('visually-hidden');
          }

          if (sliderTotalCounter) {
            sliderTotalCounter.textContent = slidesCount;
          }

          newSlider.slideTo(0);
        });

        newSlider.on('init', function() {
          const slidesCount = slider.querySelectorAll('.swiper-slide').length;

          if (slidesCount < 2) {
            if (slider.querySelector('.slider__controls')) {
              slider
                  .querySelector('.slider__controls')
                  .classList.add('visually-hidden');
              return;
            }
          }
        });

        if (slider.parentNode.querySelector('[data-counter]')) {
          newSlider.on('transitionEnd', function() {
            if (slider.querySelector('[data-counter]')) {
              slider.querySelector('[data-counter]').textContent =
                newSlider.realIndex + 1;
            }

            if (slider.querySelector('[data-slider-prev]')) {
              if (newSlider.realIndex + 1 > 1) {
                slider
                    .querySelector('[data-slider-prev]')
                    .classList.remove('visually-hidden');
              } else {
                slider
                    .querySelector('[data-slider-prev]')
                    .classList.add('visually-hidden');
              }
            }
          });
        }

        newSlider.init();
        slider.classList.add('swiper-initialized');
      }
    });
  }

  if (slidersWithThumb.length) {
    slidersWithThumb.forEach((slider) => {
      const sliderImages = slider.querySelector('[data-slider-images]');
      const sliderThumbs = slider.querySelector('[data-slider-thumbs]');

      const thumbs2 = new Swiper(sliderThumbs, {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 3,
        spaceBetween: 10,
        initialSlide: 0,
        loopedSlides: 1,

        breakpoints: {
          744: {
            direction: 'vertical',
            spaceBetween: 16,
          },
          1240: {
            direction: 'vertical',
            spaceBetween: 20,
          },
        },
      });

      const gallerySlider = new Swiper(sliderImages, {
        direction: 'horizontal',
        loop: false,

        thumbs: {
          swiper: thumbs2,
        },

        navigation: {
          nextEl: slider.querySelector('[data-slider-next]'),
          prevEl: slider.querySelector('[data-slider-prev]'),
        },

        pagination: {
          el: slider.querySelector('[data-slider-points]'),
          bulletClass: 'life-gallery__point',
          bulletActiveClass: 'life-gallery__point--active',
          clickable: false,
        },
      });

      thumbs2.on('click', function() {
        thumbs2.update();
        thumbs2.slideTo(0);
      });

      gallerySlider.on('slideChange', function() {
        thumbs2.update();
      });
    });
  }

  if (slidersWithThumbV2.length) {
    slidersWithThumbV2.forEach((slider) => {
      const sliderImages = slider.querySelector('[data-slider-images]');
      const sliderThumbs = slider.querySelector('[data-slider-thumbs]');

      const thumbs2 = new Swiper(sliderThumbs, {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 4,
        spaceBetween: 10,
        initialSlide: 0,
        loopedSlides: 1,

        breakpoints: {
          744: {
            spaceBetween: 16,
            slidesPerView: 5,
          },
        },
      });

      const gallerySlider = new Swiper(sliderImages, {
        direction: 'horizontal',
        loop: false,
        init: false,

        thumbs: {
          swiper: thumbs2,
        },

        navigation: {
          nextEl: slider.querySelector('[data-slider-next]'),
          prevEl: slider.querySelector('[data-slider-prev]'),
        },
      });

      thumbs2.on('click', function() {
        thumbs2.update();
        thumbs2.slideTo(0);
      });

      gallerySlider.on('slideChange', function() {
        thumbs2.update();
      });

      gallerySlider.on('update', function() {
        const slidesCount = slider.querySelectorAll('.swiper-slide').length;
        const sliderTotalCounter = slider.querySelector('[data-counter-total]');

        if (slidesCount < 2) {
          slider
              .querySelector('.slider__bottom')
              .classList.add('visually-hidden');
          return;
        }

        if (slider.querySelector('.slider__bottom')) {
          slider
              .querySelector('.slider__bottom')
              .classList.remove('visually-hidden');
        }

        if (sliderTotalCounter) {
          sliderTotalCounter.textContent = slidesCount;
        }

        gallerySlider.slideTo(0);
      });

      gallerySlider.on('init', function() {
        const slidesCount = slider
            .querySelector('[data-slider-images]')
            .querySelectorAll('.swiper-slide').length;
        const sliderTotalCounter = slider.querySelector('[data-counter-total]');

        if (slidesCount < 2) {
          if (slider.querySelector('.slider__bottom')) {
            slider
                .querySelector('.slider__bottom')
                .classList.add('visually-hidden');
            return;
          }
        }

        if (sliderTotalCounter) {
          sliderTotalCounter.textContent = slidesCount;
        }
      });

      if (slider.parentNode.querySelector('[data-counter]')) {
        gallerySlider.on('transitionEnd', function() {
          if (slider.querySelector('[data-counter]')) {
            slider.querySelector('[data-counter]').textContent =
              gallerySlider.realIndex + 1;
          }

          if (slider.querySelector('[data-slider-prev]')) {
            if (gallerySlider.realIndex + 1 > 1) {
              slider
                  .querySelector('[data-slider-prev]')
                  .classList.remove('visually-hidden');
            } else {
              slider
                  .querySelector('[data-slider-prev]')
                  .classList.add('visually-hidden');
            }
          }
        });
      }

      gallerySlider.init();
    });
  }
}

function initCirclesSlider() {
  console.log('init circles slider');
  const circlesSlider = document.querySelectorAll('.circles-slider');

  if (circlesSlider) {
    circlesSlider.forEach((circlesSlider) => {
      if (!circlesSlider.classList.contains('swiper-initialized')) {
        new Swiper(circlesSlider, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          direction: 'horizontal',
          pagination: {
            el: '.swiper-pagination',
          },
        });
      }
    });
  }
}

function initInfrostructureSlider() {
  console.log('init infrastructure slider');
  const infostructureSlider = document.querySelectorAll(
      '.infrastructure-slider'
  );

  if (infostructureSlider) {
    infostructureSlider.forEach((infostructureSlider) => {
      if (!infostructureSlider.classList.contains('swiper-initialized')) {
        new Swiper(infostructureSlider, {
          slidesPerView: 1,
          slidesPerGroupAuto: true,

          direction: 'horizontal',
          spaceBetween: 16,

          pagination: {
            el: '.slider__numbers',
            type: 'fraction',
          },

          navigation: {
            nextEl: '.slider__button--next',
            prevEl: '.slider__button--prev',
          },

          breakpoints: {
            744: {
              slidesPerView: 3,
            },
            1240: {
              slidesPerView: 3,
            },
          },

          // Добавляем обработчики событий
          on: {
            init() {
              // Убираем скрытие кнопок при инициализации
              this.navigation.nextEl.classList.remove('visually-hidden');
              this.navigation.prevEl.classList.remove('visually-hidden');
              // initInfrastructureFancybox();
            },
            slideChange() {
              // Убираем скрытие при каждом переключении слайда
              this.navigation.nextEl.classList.remove('visually-hidden');
              this.navigation.prevEl.classList.remove('visually-hidden');
            },
          },
        });
      }
    });
  }
}

function initDeadlinesSlider() {
  console.log('init deadlines slider');
  const deadlinesSliders = document.querySelectorAll('.deadlines__slider');

  if (deadlinesSliders) {
    deadlinesSliders.forEach((deadlinesSlider) => {
      if (!deadlinesSlider.classList.contains('swiper-initialized')) {
        new Swiper(deadlinesSlider, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          direction: 'horizontal',

          navigation: {
            nextEl: deadlinesSlider.querySelector('[data-slider-next]'),
            prevEl: deadlinesSlider.querySelector('[data-slider-prev]'),
          },

          on: {
            init() {
              updateNavigationButtons(this);
            },
            slideChange() {
              updateNavigationButtons(this);
            },
            reachEnd() {
              updateNavigationButtons(this);
            },
            reachBeginning() {
              updateNavigationButtons(this);
            },
          },
        });

        function updateNavigationButtons(deadlinesSliderElement) {
          const prevButton = document.querySelector('[data-slider-prev]');
          const nextButton = document.querySelector('[data-slider-next]');

          if (deadlinesSliderElement.isBeginning) {
            prevButton.classList.add('visually-hidden');
          } else {
            prevButton.classList.remove('visually-hidden');
          }

          if (deadlinesSliderElement.isEnd) {
            nextButton.classList.add('visually-hidden');
          } else {
            nextButton.classList.remove('visually-hidden');
          }
        }
      }
    });
  }
}

function initHistoryFacesSlider() {
  // console.log("init history faces slider");
  const historyFacesSliders = document.querySelectorAll(
      '.history-faces-slider'
  );

  if (historyFacesSliders) {
    historyFacesSliders.forEach((historyFacesSlider) => {
      if (!historyFacesSlider.classList.contains('swiper-initialized')) {
        new Swiper(historyFacesSlider, {
          direction: 'horizontal',

          slidesPerView: 'auto',

          navigation: {
            nextEl: '.swiper-faces-button-next',
            prevEl: '.swiper-faces-button-prev',
          },
        });
      }
    });
  }
}

function initHistorySlider() {
  const historySliders = document.querySelectorAll('.history-slider');
  const pageNumElement = document.querySelector('.history-page-num');

  function updatePageNumber(slideIndex, total) {
    if (!pageNumElement) {
      return;
    }

    // Удаляем все предыдущие классы с номерами
    const classList = pageNumElement.classList;
    const totalActiveSlides = total - 2;
    Array.from(classList).forEach((className) => {
      if (className.startsWith('history-page-num-')) {
        classList.remove(className);
      }
    });

    console.log(slideIndex, total - 2);
    // Добавляем новый класс с текущим номером
    classList.add(`history-page-num-${slideIndex + 1}`);
    classList.remove('history-page-pre-pre-last');
    classList.remove('history-page-pre-last');
    classList.remove('history-page-last');

    if (totalActiveSlides - (slideIndex + 1) === 2) {
      classList.remove('history-page-pre-last');
      classList.remove('history-page-last');
      classList.add('history-page-pre-pre-last');
    } else if (totalActiveSlides - (slideIndex + 1) === 1) {
      classList.remove('history-page-pre-pre-last');
      classList.remove('history-page-pre-last');
      classList.remove('history-page-last');
      classList.add('history-page-pre-last');
    } else if (totalActiveSlides - (slideIndex + 1) === 0) {
      classList.remove('history-page-pre-pre-last');
      classList.remove('history-page-pre-last');
      classList.remove('history-page-last');
      classList.add('history-page-last');
    }
  }

  function updateActiveElements(suffix) {
    document
        .querySelectorAll('[class*="history-page-control-"]')
        .forEach((el) => {
          el.classList.remove('history-page-control--active');
        });

    const control = document.querySelector(`.history-page-control-${suffix}`);
    if (control) {
      control.classList.add('history-page-control--active');
    }
  }

  function getSuffixFromElement(element) {
    for(const className of element.classList) {
      if (className.startsWith('history-page-control-')) {
        return className.replace('history-page-control-', '');
      }
    }
    return null;
  }

  if (historySliders) {
    historySliders.forEach((historySlider) => {
      if (!historySlider.classList.contains('swiper-initialized')) {
        const swiper = new Swiper(historySlider, {
          // direction: "vertical",
          // slidesPerView: 3,
          speed: 450,
          slidesPerView: 1,
          direction: 'horizontal',

          breakpoints: {
            1024: {
              slidesPerView: 3,
              // slidesPerView: "auto",
              direction: 'horizontal',
            },
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });

        historySwiper = swiper;
        let isFromUserInteraction = false;

        // 1. Обработка изменения слайда
        swiper.on('slideChange', function() {
          if (isFromUserInteraction) {
            return;
          }

          const activeSlide = this.slides[this.activeIndex];
          const card = activeSlide.querySelector('.history-slider__card');
          if (!card) {
            return;
          }

          updatePageNumber(swiper.activeIndex, swiper.slides.length);

          const suffix = getSuffixFromElement(card);
          if (!suffix) {
            return;
          }

          updateActiveElements(suffix);
          updateUrlParam(suffix);
        });

        // 2. Обработка кликов по карточкам
        historySlider
            .querySelectorAll('.history-slider__card')
            .forEach((card) => {
              card.addEventListener('click', function() {
                isFromUserInteraction = true;
                const suffix = getSuffixFromElement(this);
                if (!suffix) {
                  return;
                }

                updateActiveElements(suffix);
                updateUrlParam(suffix);

                const slide = this.closest('.swiper-slide');
                const slideIndex = Array.from(slide.parentNode.children).indexOf(
                    slide
                );
                updatePageNumber(slideIndex);
                swiper.slideTo(slideIndex);

                setTimeout(() => (isFromUserInteraction = false), 500);
              });
            });

        // 3. Обновление URL с GET-параметром
        function updateUrlParam(page) {
          const url = new URL(window.location);
          url.searchParams.set('page', page);
          history.pushState({
            page,
          }, '', url);
        }

        // 4. Обработчик изменений в истории браузера
        function handlePopState() {
          const urlParams = new URLSearchParams(window.location.search);
          const page = urlParams.get('page');
          if (!page) {
            return;
          }

          const targetCard = document.querySelector(
              `.history-page-control-${page}`
          );
          if (!targetCard) {
            return;
          }

          updateActiveElements(page);
          const slide = targetCard.closest('.swiper-slide');
          const slideIndex = Array.from(slide.parentNode.children).indexOf(
              slide
          );
          swiper.slideTo(slideIndex);
        }

        // 5. Инициализация при загрузке
        function initFromUrl() {
          const urlParams = new URLSearchParams(window.location.search);
          const page = urlParams.get('page');
          if (page) {
            handlePopState();
          } else {
            const firstCard = historySlider.querySelector(
                '.history-slider__card'
            );
            if (firstCard) {
              const suffix = getSuffixFromElement(firstCard);
              if (suffix) {
                updateActiveElements(suffix);
                updateUrlParam(suffix);
              }
            }
          }
        }
        updatePageNumber(swiper.activeIndex);
        window.addEventListener('popstate', handlePopState);
        initFromUrl();
      }
    });
  }
}

function switchHistoryTo(index, id = null) {
  if (historySwiper) {
    const currentIndex = historySwiper.activeIndex;
    const isSameSlide = currentIndex === index;

    if (!isSameSlide) {
      // Создаем обработчик для скролла после анимации
      const scrollHandler = () => {
        if (id) {
          const targetElement = document.getElementById(id);
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }
        // Удаляем обработчик после выполнения
        historySwiper.off('slideChangeTransitionEnd', scrollHandler);
      };

      historySwiper.on('slideChangeTransitionEnd', scrollHandler);
      historySwiper.slideTo(index);
    } else if (id) {
      // Если слайд уже активен - скроллим сразу
      const targetElement = document.getElementById(id);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth', block: 'start',
        });
      }
    }
  } else {
    console.warn('Слайдер не инициализирован');
  }
}

function scrollToId(id) {
  try {
    if (!id) {
      return;
    }

    const targetElement = document.getElementById(id);

    if (!targetElement) {
      return;
    }

    targetElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  } catch (error) {
    console.log('scrollToId: произошла ошибка при скролле', error);
  }
}

function initPartnersSlider() {
  const swiperEl = document.querySelector('.purchase-partners-swiper');
  if (!swiperEl) {
    return;
  }

  console.log('init partners slider');
  const swiper = new Swiper('.purchase-partners-swiper', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 8,
    watchOverflow: true, // Важно для автоматической блокировки элементов

    navigation: {
      nextEl: '.purchase-partners-swiper--next',
      prevEl: '.purchase-partners-swiper--prev',
    },

    pagination: {
      el: '.purchase-partners-swiper--pagination',
      type: 'fraction',
    },
  });

  // Функция для проверки состояния элементов управления
  function checkControlsState() {
    const controlContainer = document.querySelector(
        '.purchase-partners-swiper--control'
    );
    if (!controlContainer) {
      return;
    }

    // Получаем элементы управления
    const prevBtn = document.querySelector('.purchase-partners-swiper--prev');
    const nextBtn = document.querySelector('.purchase-partners-swiper--next');
    const pagination = document.querySelector(
        '.purchase-partners-swiper--pagination'
    );

    // Проверяем состояние всех элементов
    const prevLocked = prevBtn?.classList.contains('swiper-button-lock');
    const nextLocked = nextBtn?.classList.contains('swiper-button-lock');
    const paginationLocked = pagination?.classList.contains(
        'swiper-pagination-lock'
    );

    // Если все элементы заблокированы - добавляем класс disabled
    if (prevLocked && nextLocked && paginationLocked) {
      controlContainer.classList.add('purchase-swiper-control-disabled');
    } else {
      controlContainer.classList.remove('purchase-swiper-control-disabled');
    }
  }

  // Проверяем состояние при инициализации и после изменений
  swiper.on('init', checkControlsState);
  swiper.on('update', checkControlsState);
  swiper.on('resize', checkControlsState);
  swiper.on('slideChange', checkControlsState);
}

export {
  initSlider,
  initCirclesSlider,
  initInfrostructureSlider,
  initDeadlinesSlider,
  initHistorySlider,
  initHistoryFacesSlider,
  switchHistoryTo,
  initPartnersSlider,
  scrollToId
};
